import { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function RaffleStatusChip({
  children,
  tone = 'muted',
  className,
  ...props
}: {
  children: ReactNode;
  tone?: 'muted' | 'orange' | 'green';
  className?: string;
} & HTMLAttributes<HTMLSpanElement>) {
  const tones = {
    muted: 'border-white/20 bg-white/10 text-white',
    orange:
      'border-[rgba(255,107,61,0.45)] bg-[rgba(255,107,61,0.12)] text-[#FF6B3D]',
    green:
      'border-[rgba(80,220,120,0.45)] bg-[rgba(80,220,120,0.12)] text-[#50DC78]',
  } as const;

  return (
    <span
      {...props}
      className={cn(
        'inline-flex items-center rounded-full border px-3 py-1 font-screen-body text-[13px] font-bold uppercase tracking-[0.1em]',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
